define('AwaLabs.Tracker', [
    'underscore',
    'Tracker'
], function AwaLabsTracker(
    _,
    Tracker
) {
    'use strict';

    _.extend(Tracker.prototype, {
        trackShippingContext: function trackShippingContext(context) {
            return this.track('trackShippingContext', context);
        }
    });
});
